export default __webpack_public_path__ + "static/media/scroll.1d1c4943.svg";